import type { EntityTag, EntityTagType } from '~/types/Candidates';

export interface ApiTagEntity {
  id: number;
  name: string;
  slug: string;
}

const ROUTE_PREFIX: Record<EntityTagType, string> = {
  candidate: '/candidates',
  party: '/parties',
  campaign: '/campaigns',
};

export function mapEntityTags(
  type: EntityTagType,
  entities: ApiTagEntity[] | undefined,
): EntityTag[] {
  return (entities ?? [])
    .filter((entity) => Boolean(entity.slug))
    .map((entity) => ({
      // Prefixed with the type so ids stay unique when tags of different
      // types are concatenated into one `v-for` list.
      id: `${type}-${entity.id}`,
      label: entity.name,
      to: `${ROUTE_PREFIX[type]}/${entity.slug}`,
      type,
    }));
}
